export const GET_COURSES = 'GET_COURSES';
export const GET_CATEGORY_COURSES = 'GET_CATEGORY_COURSES';
export const GET_COURSES_BY_CATEGORY = 'GET_COURSES_BY_CATEGORY';
export const GET_COURSES_EACH_CATEGORY = 'GET_COURSES_EACH_CATEGORY'
export const GET_DETAILS_COURSES = 'GET_DETAILS_COURSES';
export const ADD_NEW_COURSE_ADMIN = 'ADD_NEW_COURSE_ADMIN';
export const GET_COURSES_ADMIN = 'GET_COURSES_ADMIN';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';